module.exports = __webpack_public_path__ + "static/media/price.88e3d876.jpg";